import React from "react";
import Content from "../components/Content";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrolltoTop from "../components/ScrolltoTop";

function Home() {
  return (
    <div className="container">
      <Header></Header>
      <Content></Content>
      <Footer></Footer>
      <ScrolltoTop></ScrolltoTop>
    </div>
  );
}

export default Home;
